import { queryOptions } from '@tanstack/react-query';
import { EventType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/event_pb';
import { assertIsNonBlankString } from '~/types/assert-type';
import { listEvents } from '~/services/api/fetchers/events.api';
import { SystemEventListModel } from '~/pages/SystemAdmin/models/SystemEventListModel';

export const LIST_SYSTEM_EVENTS_QUERY_KEY = 'listSystemEvents';

export const listSystemEventsQuery = ({
  resourceName,
}: {
  resourceName: string;
}) => {
  assertIsNonBlankString(resourceName);
  return queryOptions({
    queryKey: [
      LIST_SYSTEM_EVENTS_QUERY_KEY,
      {
        resourceName,
      },
    ],
    queryFn: async () => {
      const eventsResponse = await listEvents({
        resourceName,
        filterTypes: [
          EventType.SYSTEM_PRODUCTION_STATE_UPDATED,
          EventType.DISABLE_AUTO_MODE_COMMAND_FINISHED,
          EventType.ENABLE_AUTO_MODE_COMMAND_FINISHED,
        ],
      });
      return new SystemEventListModel(eventsResponse);
    },
    staleTime: 60 * 5_000,
  });
};
